import localForage from "localforage";
import { AsyncStorage } from "@solid-primitives/storage";
import { deflate, inflate, strFromU8, strToU8 } from "fflate";
import { isNil } from "lodash-es";

const asyncDeflate = (data: Uint8Array) =>
  new Promise((res, rej) => deflate(data, (err, out) => (err ? rej(err) : res(out))));
const asyncInflate = (data: Uint8Array): Promise<Uint8Array> =>
  new Promise((res, rej) => inflate(data, (err, out) => (err ? rej(err) : res(out))));

const createCompressedStorage = (): AsyncStorage => {
  const setItem = async (key: string, value: string) => {
    const uncompressedBytes = strToU8(value);
    const compressedBytes = await asyncDeflate(uncompressedBytes);
    return localForage.setItem(key, compressedBytes);
  };

  const getItem = async (key: string) => {
    const compressedBytes = await localForage.getItem<Uint8Array>(key);
    if (isNil(compressedBytes)) {
      return null;
    }

    const decompressedBytes = await asyncInflate(compressedBytes);
    return strFromU8(decompressedBytes);
  };

  return {
    ...localForage,
    setItem,
    getItem,
  };
};

export default createCompressedStorage;
